import Modal from './modal'

let modalInstances = null

export default {
  init: () => {
    modalInstances = Modal.initAnchors()
  },
  destroy: () => {
    if (modalInstances) {
      modalInstances.forEach((modal) => modal.destroy())
      modalInstances = null
    }
  }
}
